import { useState } from 'react'

export function AlgorithmSection() {
  const [open, setOpen] = useState(false)
  return (
    <div className="card">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between active:opacity-80"
      >
        <div className="text-ink-800 font-medium">ZSM-1.2 模型说明（点击展开）</div>
        <span className="text-ink-400 text-sm">{open ? '收起 ▴' : '展开 ▾'}</span>
      </button>

      {open && (
        <div className="mt-4 space-y-4 text-ink-700 leading-relaxed">
          <Block title="模型定位">
            ZSM-1（Zoucheng Segment Model v1）面向邹城市市直高中招生规则，回答：
            <strong className="text-ink-900">给定考生分数，把某所学校填为第一志愿的录取概率是多少。</strong>
          </Block>

          <Block title="核心机制">
            <ul className="list-disc pl-5 space-y-1">
              <li>以前 300 名分数线为上界，向下每 10 分一段（分段顺位录取 · Banded Tier Admission）</li>
              <li>每段内五校按当年公告比例分配名额</li>
              <li>一中推荐生按公告分段扣减一中名额，并从普通志愿竞争人数中剔除</li>
              <li>段内按分数从高到低依次处理志愿</li>
              <li>
                录取概率 = 「段内你前方填同一所学校的人数 &lt; 该校名额」的概率（二项模型）；
                报名偏好用 Dirichlet 先验抽样 200 次，给出 20%–80% 区间
              </li>
            </ul>
          </Block>

          <Block title="数据来源">
            <ul className="list-disc pl-5 space-y-1">
              <li>政策行 / 前 300 线 / 五校比例：邹城市教体局历年公告，三方公开核对</li>
              <li>分段表：教体局公告附图（2025 已核对，2024 / 2023 正在复核）</li>
              <li>报名偏好矩阵：本地教研经验先验，将通过用户回填数据持续校准</li>
            </ul>
          </Block>

          <Block title="已知局限">
            <ul className="list-disc pl-5 space-y-1">
              <li>段内人数按密度模型重建（非一分一段真实表），位置估计可能有误差</li>
              <li>偏好矩阵为先验估计，尚未用真实回填数据校准；对热门校（如二中）区间偏宽属正常</li>
              <li>不建模第二志愿调剂、特长生，以及未完成指标生计划产生的降分补录细节</li>
            </ul>
          </Block>

          <Block title="隐私">
            <ul className="list-disc pl-5 space-y-1">
              <li>分数计算全部在本地浏览器进行，不上传任何服务器</li>
              <li>仅当用户主动回填录取结果时，才会上送分数、第一志愿、录取学校三个字段</li>
              <li>不收集姓名、手机号、身份证号、初中校等任何身份信息</li>
            </ul>
          </Block>

          <div className="pt-2 border-t border-ink-100 text-ink-400 text-xs leading-relaxed">
            模型：ZSM-1.2（Zoucheng Segment Model）· 分段顺位录取 · Dirichlet–Beta-Binomial
            概率口径 · 蒙特卡洛区间估计
          </div>
        </div>
      )}
    </div>
  )
}

function Block({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <div className="text-ink-900 font-medium mb-1">{title}</div>
      <div className="text-ink-700">{children}</div>
    </div>
  )
}
